export const ACTUALIZAR_LIST_PRODUCTO = "ACTUALIZAR_LIST_PRODUCTO";
export const ACTUALIZAR__LIST_ACTIVOXPRODUCTO = 'ACTUALIZAR__LIST_ACTIVOXPRODUCTO';